import http, {configJson} from "@/api/config/http-configs";

// addOption {"accountId":1,"type":"员工下载","request":"这里是请求的参数","response":"这里是返回的结果"}
export const addOption = (data) => {
    return http.post("/manage/log/add/operate", data, configJson);
}

// /log/list/sms
export const getListSms = (pageIndex, pageSize) => {
    const url = "manage/log/list/sms"
    const page = {current: pageIndex, size: pageSize}
    return http.post(url, page, configJson);
}

// /log/list/operate
export const getListOperate = (pageIndex, pageSize) => {
    const url = "manage/log/list/operate"
    const page = {current: pageIndex, size: pageSize}
    return http.post(url, page, configJson);
}

// /log/list/sync
export const getListSync = (pageIndex, pageSize) => {
    const url = "/manage/log/list/sync/contacts"
    const page = {current: pageIndex, size: pageSize}
    return http.post(url, page, configJson);
}

// /manage/log/list/trans/sms
// 短信赠送数量查询
export const getListTransSms = () => {
    const url = '/manage/log/list/trans/sms'
    return http.get(url);
}

// /manage/log/list/backup
// 备份记录查询
export const getListBackup = (pageIndex, pageSize) => {
    const url = '/manage/log/list/backup'
    const page = {current: pageIndex, size: pageSize}
    return http.post(url, page, configJson);
}
